import React from 'react'

import { Skeleton as MUISkeleton } from '@mui/material'

import { Box } from '../'

import { Color } from '@/utils'

const Skeleton = ({
 width = '100%',
 height = '6px',
 variant = 'rectangular',
 animation = 'wave',
 borderRadius = '4px',
 absolute = false,
}) => (
    <Box
        width={width}
        height={height}
        position={absolute ? 'absolute' : 'relative'}
        top={0}
        left={0}
        visibility="visible"
    >
        <MUISkeleton
            variant={variant}
            animation={animation}
            height="100%"
            width="100%"
            sx={{ bgcolor: Color.lightGrayHover, borderRadius: { borderRadius } }}
        />
    </Box>
)

export { Skeleton }
